module.exports = "https://dev.stanwinstonschool.com/terminator_2_poster_org.6af1a10aebfbfa13ebe06c6173984fbb.jpg";